import { PureComponent } from 'react'

const initialContainer = {
  initialState: {},
  handlers: () => {},
  render: () => {}
}

export const compose = (...fns) => obj => fns.reduce((acc, fn) => fn(acc), obj)

export const classMap = (container = initialContainer) => {
  function Container(props) {
    PureComponent.call(this, props)
    if (container.handlers) { this.handle = container.handlers(this) }
  }

  Container.prototype = Object.create(PureComponent.prototype)
  Container.prototype.constructor = Container
  Container.prototype.state = container.initialState
  Container.prototype.render = container.render

  Container.prototype.componentWillReceiveProps = function(nextProps) {
    if (this.handle && this.handle.receiveProps) {
      return this.handle.receiveProps(nextProps)
    }
  }
  Container.prototype.componentDidMount = function() {
    if (this.handle && this.handle.mount) { return this.handle.mount() }
  }
  Container.prototype.componentWillUnmount = function() {
    if (this.handle && this.handle.unmount) { return this.handle.unmount() }
  }
  return Container
}
